import {
    AlertLink,
    BannerAlertType,
} from '@thoughtspot/radiant-react/widgets/alert';

export enum AnswerBannerType {
    ChartConfigChangedInfoMessage = 'ChartConfigChangedInfoMessage',
}
export type AnswerAlertBanner = {
    type: BannerAlertType;
    message: string;
    link?: AlertLink;
    onClose?: () => void;
};
export type ChartConfigUpdateStatus = {
    isUpdated: boolean;
};
export const UNDEFINED_DISPLAYMODE = 'UNDEFINED';

const configMap: any = {
    [AnswerBannerType.ChartConfigChangedInfoMessage]: {
        type: BannerAlertType.INFO,
    },
};

export const answerBannerType = (
    bannerConfigType: string,
): AnswerAlertBanner => {
    const config: AnswerAlertBanner = configMap[bannerConfigType];
    return config;
};
